import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const DailyPlanList = Loadable(lazy(() => import("./DailyPlanList")));
const DailyPlanForm = Loadable(lazy(() => import("./DailyPlanForm")));

const dailyPlanRoutes = [
  {
    path: "/DailyPlan/DailyPlanList",
    element: <DailyPlanList />,
    permission: PERMISSIONS.DailyPlans.Menu,
  },
  {
    path: "/DailyPlan/DailyPlanForm",
    element: <DailyPlanForm />,
  },
  {
    path: "/DailyPlan/DailyPlanForm/:dailyPlanId",
    element: <DailyPlanForm />,
  },
];

export default dailyPlanRoutes;
